const INFO = {
	main: {
		title: "Manase Gunga",
		name: "Manase Gunga",
		email: "manasegunga@gmail.com",
		logo: "../logo.jpeg",
	},

	socials: {
		github: "https://github.com/Manase44",
		linkedin: "https://linkedin.com/in/nasegunga",
		instagram: "https://instagram.com/nasegunga",
		phone: "+254758070094",
	},

	homepage: {
		title: "Software Engineering | Data Science | Public Speaking",
		description:
			"I’m a software engineer who thrives at the intersection of creativity, logic, and impact. Over the years, I’ve built solid experience working across the stack — from crafting responsive frontend interfaces to developing reliable backend systems.My love for technology extends beyond software development into data science. I’ve completed several independent data projects that have strengthened my analytical thinking and fueled my pursuit of mastering machine learning.Beyond code, I’m deeply inspired by growth and collaboration. I enjoy being part of tech communities that foster innovation and knowledge-sharing, and I actively seek spaces where I can both learn and contribute. I’m also nurturing my passion for public speaking, aiming to inspire others through storytelling and shared experiences in tech.",
	},

	project: {
		title: "Things I’ve Built",
		description:
			"Here are some of the projects I’ve worked on, spanning full-stack development and data science. Each project has a GitHub link and a live demo — if the GitHub link is disabled, it’s likely a private repo, and if the live demo is inactive, the site might be down. Feel free to explore and see how I bring ideas to life through code.",
	},

	about: {
		title: "My Journey in Tech",
		description:
			"From frontend engineering to backend architecture and data exploration, my experience reflects a deep passion for solving real problems with technology. I’ve worked on diverse projects, taken on multiple roles, and continually refined my skills to stay adaptable in an ever-evolving tech landscape.",
	},

	blog: {
		title: "My Blog",
		description: "description",
	},

	work: [
		{
			title: "Software Development Attaché",
			compnay: "Teach2Give",
			description:
				"Contributed to backend and frontend projects while deepening my understanding of software architecture and collaborative development.",
			logo: "../teach2give.jpg",
			date: "May 2024 – July 2024",
			type: "work",
			bgColor: "#00ADB5",
		},
		{
			title: "Software Developer Intern",
			compnay: "Affam",
			description:
				"Developed and maintained large-scale web applications using Next.js and Django REST Framework. Collaborated across teams to deliver efficient, scalable, and user-focused solutions.",
			logo: "../affam.png",
			date: "Aug 2024 – Feb 2025",
			type: "work",
			bgColor: "#393E46",
		},
		{
			title: "Cohort 9 Mentee",
			compnay: "KamiLimu",
			description:
				"Selected for a competitive mentorship program focusing on technical excellence, personal growth, and community impact through projects and mentorship sessions.",
			logo: "../KamiLimu.png",
			date: "Mar 2025 – Nov 2025",
			type: "education",
			bgColor: "#222831",
		},
	],

projects: [
		{
			title: "Online Bursary Application",
			logo: "../oba.png",
			description:
				"A model-powered web portal for bursary application that uses machine learning to predict a student's need for financial aid. Features include application tracking, admin dashboards, and prediction analytics.",
			technologies: ["React", "Tailwind", "TypeScript", "Express"],
			githubLink: "https://github.com/Manase44/oba_frontend_25",
			liveLink: null,
		},
		{
			title: "Mutmee",
			logo: "../mutmee.png",
			description:
				"An Instagram-inspired social media platform built for my university community to facilitate communication, sharing, and engagement among students and faculty.",
			technologies: ["React", "Tailwind", "JavaScript", "Express"],
			githubLink: "https://github.com/Manase44/Mutmee",
			liveLink: "https://mutmee.vercel.app/",
		},
		{
			title: "Sir Philips Ranch eCommerce Platform",
			logo: "../sirphillipranch.png",
			description:
				"A scalable and performant eCommerce platform for Sir Philips Industries, built with modern UI and backend optimization for high transaction reliability.",
			technologies: ["React", "Tailwind", "TypeScript", "Fastify"],
			githubLink: "",
			liveLink: "",
		},
		{
			title: "Dr Mordi Medical Web App",
			logo: "../drmordi.png",
			description:
				"Contributed to Dr Mordi — a large-scale medical management web application still under development, integrating patient data, scheduling, and clinical modules.",
			technologies: ["Next.js", "Tailwind", "TypeScript", "Flask"],
			githubLink: null,
			liveLink: "https://dr-mordi-doctors.vercel.app/",
		},
		{
			title: "Vice Queens Industries eCommerce App",
			logo: "../vicequeens.png",
			description:
				"Developed a full-featured eCommerce application for Vice Queens Industries with real-time product management, order tracking, and responsive UI.",
			technologies: ["React", "Tailwind", "TypeScript", "Fastify"],
			githubLink: null,
			liveLink: "https://vice-queen-industries.vercel.app",
		},
		{
			title: "VasLink Landing Page",
			logo: "../vaslink.png",
			description:
				"Designed and implemented the landing page for VasLink, emphasizing clean design and responsiveness to effectively communicate the company’s offerings.",
			technologies: ["Django", "HTML", "CSS", "Tailwind"],
			githubLink: null,
			liveLink: "https://vaslinkcomm.com/",
		},
		{
			title: "Lengo Sacco Society Website",
			logo: "../lengosacco.png",
			description:
				"Redesigned and developed the official website for Lengo Sacco Society Ltd, enhancing user experience and providing comprehensive information about their financial services.",
			technologies: ["JOOMLA", "HTML", "CSS"],
			githubLink: null,
			liveLink: "https://lengosacco.org/",
		},
		{
			title: "Huminexia Quant Solutions LLC Website",
			logo: "../huminexia.png",
			description:
				"Collaborated on the development of the Huminexia Quant Solutions LLC website, focusing on a modern design and seamless user experience to showcase their services.",
			technologies: ["Django", "HTML", "CSS"],
			githubLink: null,
			liveLink: "https://huminexia.com/",
		},
	],
};

export default INFO;
